<div class="form-wrapper">
  <form class="section" [formGroup]="form">
    <div class="lna-row full-width no-margin">
      <div class="label-wrapper">
        <label class="form-label lna" for="requiresRestrictedAccess">
          {{ 'pages.service.visitRoom.orderDocuments' | translate }}
        </label>
        <app-tooltip text="orderDocumentsFieldBackoffice" />
      </div>
      <div class="radio-buttons">
        <div class="radio-wrapper">
          <input id="no" [value]="false" type="radio" formControlName="hasRequestedDocuments" />
          <label for="inactive">{{ 'components.form.no' | translate }}</label>
        </div>
        <div class="radio-wrapper">
          <input id="yes" [value]="true" type="radio" formControlName="hasRequestedDocuments" />
          <label for="active">{{ 'components.form.yes' | translate }}</label>
        </div>
      </div>
    </div>
    @if (form.get('hasRequestedDocuments')?.value) {
    <div class="info-row_wrapper">
      <div class="info-row">
        <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
        <p>
          {{ 'pages.service.visitRoom.additionalHasDocumentOrder1' | translate }}
        </p>
      </div>
      <div class="info-row">
        <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
        <p>
          {{ 'pages.service.visitRoom.additionalHasDocumentOrder2' | translate }}
        </p>
      </div>
      <div class="info-row">
        <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
        <p>
          {{ 'pages.service.visitRoom.additionalHasDocumentOrder3' | translate }}
        </p>
      </div>
    </div>
    }
  </form>
  @if (hasRequestedDocuments?.value) {
  <form class="section no-padding" [formGroup]="form">
    <div class="heading-wrapper">
      <div class="label-wrapper mb-0">
        <h5 class="mb-0">
          {{ 'pages.service.visitRoom.documents' | translate }}
          <span>({{ documents.controls.length }}/30)</span>
        </h5>
        <app-tooltip text="readingRoomDocumentsBackoffice" [marginBottom]="false"></app-tooltip>
      </div>
      <div class="d-flex button-wrapper">
        <app-document-info-modal />
      </div>
    </div>
    <div class="documents-wrapper">
      <div class="document-header">
        <div class="label-wrapper heading-cell">
          <p>
            {{ 'pages.service.visitRoom.documentHeaderCode' | translate }}
          </p>
          <app-tooltip [marginBottom]="false" text="documentCodeBackoffice" />
        </div>
        <div class="label-wrapper heading-cell">
          <p>{{ 'pages.service.visitRoom.documentNotes' | translate }}</p>
          <app-tooltip [marginBottom]="false" text="orderDocumentNotesBackoffice" />
        </div>
      </div>
      <div formArrayName="requestedDocuments">
        @for (doc of documents.controls; track doc) {
        <div class="document-wrapper" [formGroupName]="$index">
          <div class="input-wrapper">
            <input class="form-control lna" id="code" [ngClass]="{ invalid: this.shouldRenderError('code') }"
              maxlength="{{ maxDocumentCodeLength }}" type="text" formControlName="code" name="code" />
          </div>
          <div class="input-wrapper">
            <input class="form-control lna" id="notes" [ngClass]="{ invalid: this.shouldRenderError('notes') }"
              maxlength="{{ maxNotesLength }}" type="text" formControlName="notes" name="notes" />
          </div>
          <button class="link-btn" (click)="deleteDocument($index)">
            <img [attr.alt]="'imgAlt.delete' | translate" src="assets/images/delete-icon.svg" />
          </button>
        </div>
        }
      </div>
      @if (documents.length === 0) {
      <p class="no-documents">
        {{ 'pages.service.visitRoom.noDocuments' | translate }}
      </p>
      }
      @if (documents.controls.length < 30) { <div class="addDocument_wrapper">
        <button class="tertiary addDocument" (click)="addDocument()">
          <i class="bi bi-plus-circle add-icon" [attr.alt]="'imgAlt.document' | translate"></i>
          {{ 'pages.service.visitRoom.addDocument' | translate }}
        </button>
    </div>
    }
    <div class="order-notes-wrapper">
      <div class="label-wrapper">
        <label class="form-label lna" for="documentOrderInformation">
          {{ 'pages.service.visitRoom.orderNotes' | translate }}
        </label>
        <app-tooltip text="visitRoomOrderNotesBo" />
      </div>
      <div class="textarea-wrapper">
        <textarea class="form-control lna" id="requestedDocumentsInformation" [ngClass]="{
                invalid: shouldRenderError('requestedDocumentsInformation')
              }" type="text" formControlName="requestedDocumentsInformation" name="requestedDocumentsInformation"
          maxlength="{{ maxDocumentNotesLength }}"></textarea>
        <p class="length" [ngClass]="{
                invalid: requestedDocumentsInformation?.value.length > maxDocumentNotesLength
              }">
          {{ requestedDocumentsInformation?.value.length }}/{{ maxDocumentNotesLength }}
        </p>
      </div>
    </div>
</div>
</form>
}
</div>
<app-confirm-modal [isOpen]="isOpenConfirmBack" (confirm)="back(true)" (cancel)="isOpenConfirmBack = false"
  title="unsavedChanges" bodyText="unsavedChangesBody" confirmText="continue" denyText="cancelBack" />
<app-confirm-modal [title]="'deleteReadingRoomSubmission'" [confirmText]="'delete'"
  [isOpen]="isOpenConfirmDeleteSubmission" (confirm)="deleteReadingRoomSubmission()" (cancel)="onModalClose()" />
<app-service-form-actions (exit)="back()" (saveDraft)="handleSaveDraft()" (continue)="submit(true)"
  (deleteDraft)="handleDeleteDraft()" />
